/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShipQuantityPlan } from './ShipQuantityPlan';
import {
    ShipQuantityPlanFromJSON,
    ShipQuantityPlanFromJSONTyped,
    ShipQuantityPlanToJSON,
    ShipQuantityPlanToJSONTyped,
} from './ShipQuantityPlan';
import type { ArrivalQuantityPlan } from './ArrivalQuantityPlan';
import {
    ArrivalQuantityPlanFromJSON,
    ArrivalQuantityPlanFromJSONTyped,
    ArrivalQuantityPlanToJSON,
    ArrivalQuantityPlanToJSONTyped,
} from './ArrivalQuantityPlan';

/**
 * 
 * @export
 * @interface Stock
 */
export interface Stock {
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    companyId: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    centerId: number | null;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    orgCenterId: string | null;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    centerName: string | null;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    orgItemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    orgItemCodeRecency: string | null;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    itemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    orgSupplierId: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Stock
     */
    recDate: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Stock
     */
    orderDate: Date | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    weekNo: number | null;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    dateType: string | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    orderQuantityRec: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    arrivalQuantity: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    salesorderQuantity: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    shipQuantity: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    shipQuantityRec: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    stockQuantity: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    stockQuantityRec: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    stockDays: number | null;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    orderQuantityReason: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    enableUpdateShip: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    enableUpdateArrival: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    shipQuantityExpected: number | null;
    /**
     * 
     * @type {Date}
     * @memberof Stock
     */
    shipExpectedCalcDatetime: Date | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    arrivalQuantityPallet: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    shipQuantityPallet: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    stockQuantityPallet: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    salesorderQuantityPallet: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    generalCustomerShipQuantity: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    customerOrderQuantityRecommend: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    shipQuantityScheduled: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    orderQuantityRecommend: number | null;
    /**
     * 
     * @type {Date}
     * @memberof Stock
     */
    orderRecommendCalcDatetime: Date | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    stockQuantityRecMorning: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    enableShip: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    enableArrival: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    supplierEnableOrder: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    enableOrder: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    isUpdatedArrival: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    isUpdatedShip: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    supplierCompanyId: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    arrivalFixFlg: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    stockDaysSetting: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    safetyStockSetting: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    minStockQuantity: number | null;
    /**
     * 
     * @type {Date}
     * @memberof Stock
     */
    startDate: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    stopShip: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    stopArrival: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof Stock
     */
    endDate: Date | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    renewalNumber: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    renewalFlg: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    newitemStartFlg: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    olditemShipStopFlg: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    remarks: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    shipExclusionFlg: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    shipQuantityInterpolated: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    shipQuantityPredictBase: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    shipQuantityOptimizeBase: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    arrivalRatio: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    weightCalc: number | null;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    optimizeType: string | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    dateno: number | null;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    rectype: string | null;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    colname: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Stock
     */
    datevalue: Date | null;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    rectypeName: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Stock
     */
    insertDatetime: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Stock
     */
    updateDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    insertUser: string | null;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    updateUser: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Stock
     */
    deleteDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    deleteUser: string | null;
    /**
     * 
     * @type {ShipQuantityPlan}
     * @memberof Stock
     */
    shipQuantityPlan: ShipQuantityPlan | null;
    /**
     * 
     * @type {ArrivalQuantityPlan}
     * @memberof Stock
     */
    arrivalQuantityPlan: ArrivalQuantityPlan | null;
    /**
     * 
     * @type {Date}
     * @memberof Stock
     */
    stockPlanUpdateDatetime: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Stock
     */
    updateDatetimeRec: Date | null;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    updateUserRec: string | null;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    updateUserRecName: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    isUpdatedArrivalTmp: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    isOrderConfirmed: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    orderQuantity: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    shipQuantityStockBase: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    avgShipQuantityStockBase: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    orderQuantityLpResult: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    minStockForecastBased: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    minStockShortageBased: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    calcSafety: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    isOrderQuantityFixed: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    predictionMethod: string | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    numTrain: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    yearlySeasonality: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    predictionMapeMedian: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    isArrivalDay: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    isOrderDay: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    arrivalFixDate: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    shipdaysNextArrival: number | null;
    /**
     * 
     * @type {Date}
     * @memberof Stock
     */
    minShipDate: Date | null;
    /**
     * 
     * @type {number}
     * @memberof Stock
     */
    stockQuantityShipStop: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    alertShipPreviousStock: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    alertLowStock: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    alertOutOfStock: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    masterNotFound: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    isInactive: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    unmatchLot: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    unmatchStockdays: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    unmatchRenewal: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    isExpectedRankAlert: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    isMinShipDateAlert: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Stock
     */
    isEndSaleAlert: boolean | null;
}

/**
 * Check if a given object implements the Stock interface.
 */
export function instanceOfStock(value: object): value is Stock {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('centerId' in value) || value['centerId'] === undefined) return false;
    if (!('orgCenterId' in value) || value['orgCenterId'] === undefined) return false;
    if (!('centerName' in value) || value['centerName'] === undefined) return false;
    if (!('orgItemCode' in value) || value['orgItemCode'] === undefined) return false;
    if (!('orgItemCodeRecency' in value) || value['orgItemCodeRecency'] === undefined) return false;
    if (!('itemCode' in value) || value['itemCode'] === undefined) return false;
    if (!('orgSupplierId' in value) || value['orgSupplierId'] === undefined) return false;
    if (!('recDate' in value) || value['recDate'] === undefined) return false;
    if (!('orderDate' in value) || value['orderDate'] === undefined) return false;
    if (!('weekNo' in value) || value['weekNo'] === undefined) return false;
    if (!('dateType' in value) || value['dateType'] === undefined) return false;
    if (!('orderQuantityRec' in value) || value['orderQuantityRec'] === undefined) return false;
    if (!('arrivalQuantity' in value) || value['arrivalQuantity'] === undefined) return false;
    if (!('salesorderQuantity' in value) || value['salesorderQuantity'] === undefined) return false;
    if (!('shipQuantity' in value) || value['shipQuantity'] === undefined) return false;
    if (!('shipQuantityRec' in value) || value['shipQuantityRec'] === undefined) return false;
    if (!('stockQuantity' in value) || value['stockQuantity'] === undefined) return false;
    if (!('stockQuantityRec' in value) || value['stockQuantityRec'] === undefined) return false;
    if (!('stockDays' in value) || value['stockDays'] === undefined) return false;
    if (!('orderQuantityReason' in value) || value['orderQuantityReason'] === undefined) return false;
    if (!('enableUpdateShip' in value) || value['enableUpdateShip'] === undefined) return false;
    if (!('enableUpdateArrival' in value) || value['enableUpdateArrival'] === undefined) return false;
    if (!('shipQuantityExpected' in value) || value['shipQuantityExpected'] === undefined) return false;
    if (!('shipExpectedCalcDatetime' in value) || value['shipExpectedCalcDatetime'] === undefined) return false;
    if (!('arrivalQuantityPallet' in value) || value['arrivalQuantityPallet'] === undefined) return false;
    if (!('shipQuantityPallet' in value) || value['shipQuantityPallet'] === undefined) return false;
    if (!('stockQuantityPallet' in value) || value['stockQuantityPallet'] === undefined) return false;
    if (!('salesorderQuantityPallet' in value) || value['salesorderQuantityPallet'] === undefined) return false;
    if (!('generalCustomerShipQuantity' in value) || value['generalCustomerShipQuantity'] === undefined) return false;
    if (!('customerOrderQuantityRecommend' in value) || value['customerOrderQuantityRecommend'] === undefined) return false;
    if (!('shipQuantityScheduled' in value) || value['shipQuantityScheduled'] === undefined) return false;
    if (!('orderQuantityRecommend' in value) || value['orderQuantityRecommend'] === undefined) return false;
    if (!('orderRecommendCalcDatetime' in value) || value['orderRecommendCalcDatetime'] === undefined) return false;
    if (!('stockQuantityRecMorning' in value) || value['stockQuantityRecMorning'] === undefined) return false;
    if (!('enableShip' in value) || value['enableShip'] === undefined) return false;
    if (!('enableArrival' in value) || value['enableArrival'] === undefined) return false;
    if (!('supplierEnableOrder' in value) || value['supplierEnableOrder'] === undefined) return false;
    if (!('enableOrder' in value) || value['enableOrder'] === undefined) return false;
    if (!('isUpdatedArrival' in value) || value['isUpdatedArrival'] === undefined) return false;
    if (!('isUpdatedShip' in value) || value['isUpdatedShip'] === undefined) return false;
    if (!('supplierCompanyId' in value) || value['supplierCompanyId'] === undefined) return false;
    if (!('arrivalFixFlg' in value) || value['arrivalFixFlg'] === undefined) return false;
    if (!('stockDaysSetting' in value) || value['stockDaysSetting'] === undefined) return false;
    if (!('safetyStockSetting' in value) || value['safetyStockSetting'] === undefined) return false;
    if (!('minStockQuantity' in value) || value['minStockQuantity'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('stopShip' in value) || value['stopShip'] === undefined) return false;
    if (!('stopArrival' in value) || value['stopArrival'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('renewalNumber' in value) || value['renewalNumber'] === undefined) return false;
    if (!('renewalFlg' in value) || value['renewalFlg'] === undefined) return false;
    if (!('newitemStartFlg' in value) || value['newitemStartFlg'] === undefined) return false;
    if (!('olditemShipStopFlg' in value) || value['olditemShipStopFlg'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    if (!('shipExclusionFlg' in value) || value['shipExclusionFlg'] === undefined) return false;
    if (!('shipQuantityInterpolated' in value) || value['shipQuantityInterpolated'] === undefined) return false;
    if (!('shipQuantityPredictBase' in value) || value['shipQuantityPredictBase'] === undefined) return false;
    if (!('shipQuantityOptimizeBase' in value) || value['shipQuantityOptimizeBase'] === undefined) return false;
    if (!('arrivalRatio' in value) || value['arrivalRatio'] === undefined) return false;
    if (!('weightCalc' in value) || value['weightCalc'] === undefined) return false;
    if (!('optimizeType' in value) || value['optimizeType'] === undefined) return false;
    if (!('dateno' in value) || value['dateno'] === undefined) return false;
    if (!('rectype' in value) || value['rectype'] === undefined) return false;
    if (!('colname' in value) || value['colname'] === undefined) return false;
    if (!('datevalue' in value) || value['datevalue'] === undefined) return false;
    if (!('rectypeName' in value) || value['rectypeName'] === undefined) return false;
    if (!('insertDatetime' in value) || value['insertDatetime'] === undefined) return false;
    if (!('updateDatetime' in value) || value['updateDatetime'] === undefined) return false;
    if (!('insertUser' in value) || value['insertUser'] === undefined) return false;
    if (!('updateUser' in value) || value['updateUser'] === undefined) return false;
    if (!('deleteDatetime' in value) || value['deleteDatetime'] === undefined) return false;
    if (!('deleteUser' in value) || value['deleteUser'] === undefined) return false;
    if (!('shipQuantityPlan' in value) || value['shipQuantityPlan'] === undefined) return false;
    if (!('arrivalQuantityPlan' in value) || value['arrivalQuantityPlan'] === undefined) return false;
    if (!('stockPlanUpdateDatetime' in value) || value['stockPlanUpdateDatetime'] === undefined) return false;
    if (!('updateDatetimeRec' in value) || value['updateDatetimeRec'] === undefined) return false;
    if (!('updateUserRec' in value) || value['updateUserRec'] === undefined) return false;
    if (!('updateUserRecName' in value) || value['updateUserRecName'] === undefined) return false;
    if (!('isUpdatedArrivalTmp' in value) || value['isUpdatedArrivalTmp'] === undefined) return false;
    if (!('isOrderConfirmed' in value) || value['isOrderConfirmed'] === undefined) return false;
    if (!('orderQuantity' in value) || value['orderQuantity'] === undefined) return false;
    if (!('shipQuantityStockBase' in value) || value['shipQuantityStockBase'] === undefined) return false;
    if (!('avgShipQuantityStockBase' in value) || value['avgShipQuantityStockBase'] === undefined) return false;
    if (!('orderQuantityLpResult' in value) || value['orderQuantityLpResult'] === undefined) return false;
    if (!('minStockForecastBased' in value) || value['minStockForecastBased'] === undefined) return false;
    if (!('minStockShortageBased' in value) || value['minStockShortageBased'] === undefined) return false;
    if (!('calcSafety' in value) || value['calcSafety'] === undefined) return false;
    if (!('isOrderQuantityFixed' in value) || value['isOrderQuantityFixed'] === undefined) return false;
    if (!('predictionMethod' in value) || value['predictionMethod'] === undefined) return false;
    if (!('numTrain' in value) || value['numTrain'] === undefined) return false;
    if (!('yearlySeasonality' in value) || value['yearlySeasonality'] === undefined) return false;
    if (!('predictionMapeMedian' in value) || value['predictionMapeMedian'] === undefined) return false;
    if (!('isArrivalDay' in value) || value['isArrivalDay'] === undefined) return false;
    if (!('isOrderDay' in value) || value['isOrderDay'] === undefined) return false;
    if (!('arrivalFixDate' in value) || value['arrivalFixDate'] === undefined) return false;
    if (!('shipdaysNextArrival' in value) || value['shipdaysNextArrival'] === undefined) return false;
    if (!('minShipDate' in value) || value['minShipDate'] === undefined) return false;
    if (!('stockQuantityShipStop' in value) || value['stockQuantityShipStop'] === undefined) return false;
    if (!('alertShipPreviousStock' in value) || value['alertShipPreviousStock'] === undefined) return false;
    if (!('alertLowStock' in value) || value['alertLowStock'] === undefined) return false;
    if (!('alertOutOfStock' in value) || value['alertOutOfStock'] === undefined) return false;
    if (!('masterNotFound' in value) || value['masterNotFound'] === undefined) return false;
    if (!('isInactive' in value) || value['isInactive'] === undefined) return false;
    if (!('unmatchLot' in value) || value['unmatchLot'] === undefined) return false;
    if (!('unmatchStockdays' in value) || value['unmatchStockdays'] === undefined) return false;
    if (!('unmatchRenewal' in value) || value['unmatchRenewal'] === undefined) return false;
    if (!('isExpectedRankAlert' in value) || value['isExpectedRankAlert'] === undefined) return false;
    if (!('isMinShipDateAlert' in value) || value['isMinShipDateAlert'] === undefined) return false;
    if (!('isEndSaleAlert' in value) || value['isEndSaleAlert'] === undefined) return false;
    return true;
}

export function StockFromJSON(json: any): Stock {
    return StockFromJSONTyped(json, false);
}

export function StockFromJSONTyped(json: any, ignoreDiscriminator: boolean): Stock {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'centerId': json['center_id'],
        'orgCenterId': json['org_center_id'],
        'centerName': json['center_name'],
        'orgItemCode': json['org_item_code'],
        'orgItemCodeRecency': json['org_item_code_recency'],
        'itemCode': json['item_code'],
        'orgSupplierId': json['org_supplier_id'],
        'recDate': (json['rec_date'] == null ? null : new Date(json['rec_date'])),
        'orderDate': (json['order_date'] == null ? null : new Date(json['order_date'])),
        'weekNo': json['week_no'],
        'dateType': json['date_type'],
        'orderQuantityRec': json['order_quantity_rec'],
        'arrivalQuantity': json['arrival_quantity'],
        'salesorderQuantity': json['salesorder_quantity'],
        'shipQuantity': json['ship_quantity'],
        'shipQuantityRec': json['ship_quantity_rec'],
        'stockQuantity': json['stock_quantity'],
        'stockQuantityRec': json['stock_quantity_rec'],
        'stockDays': json['stock_days'],
        'orderQuantityReason': json['order_quantity_reason'],
        'enableUpdateShip': json['enable_update_ship'],
        'enableUpdateArrival': json['enable_update_arrival'],
        'shipQuantityExpected': json['ship_quantity_expected'],
        'shipExpectedCalcDatetime': (json['ship_expected_calc_datetime'] == null ? null : new Date(json['ship_expected_calc_datetime'])),
        'arrivalQuantityPallet': json['arrival_quantity_pallet'],
        'shipQuantityPallet': json['ship_quantity_pallet'],
        'stockQuantityPallet': json['stock_quantity_pallet'],
        'salesorderQuantityPallet': json['salesorder_quantity_pallet'],
        'generalCustomerShipQuantity': json['general_customer_ship_quantity'],
        'customerOrderQuantityRecommend': json['customer_order_quantity_recommend'],
        'shipQuantityScheduled': json['ship_quantity_scheduled'],
        'orderQuantityRecommend': json['order_quantity_recommend'],
        'orderRecommendCalcDatetime': (json['order_recommend_calc_datetime'] == null ? null : new Date(json['order_recommend_calc_datetime'])),
        'stockQuantityRecMorning': json['stock_quantity_rec_morning'],
        'enableShip': json['enable_ship'],
        'enableArrival': json['enable_arrival'],
        'supplierEnableOrder': json['supplier_enable_order'],
        'enableOrder': json['enable_order'],
        'isUpdatedArrival': json['is_updated_arrival'],
        'isUpdatedShip': json['is_updated_ship'],
        'supplierCompanyId': json['supplier_company_id'],
        'arrivalFixFlg': json['arrival_fix_flg'],
        'stockDaysSetting': json['stock_days_setting'],
        'safetyStockSetting': json['safety_stock_setting'],
        'minStockQuantity': json['min_stock_quantity'],
        'startDate': (json['start_date'] == null ? null : new Date(json['start_date'])),
        'stopShip': json['stop_ship'],
        'stopArrival': json['stop_arrival'],
        'endDate': (json['end_date'] == null ? null : new Date(json['end_date'])),
        'renewalNumber': json['renewal_number'],
        'renewalFlg': json['renewal_flg'],
        'newitemStartFlg': json['newitem_start_flg'],
        'olditemShipStopFlg': json['olditem_ship_stop_flg'],
        'remarks': json['remarks'],
        'shipExclusionFlg': json['ship_exclusion_flg'],
        'shipQuantityInterpolated': json['ship_quantity_interpolated'],
        'shipQuantityPredictBase': json['ship_quantity_predict_base'],
        'shipQuantityOptimizeBase': json['ship_quantity_optimize_base'],
        'arrivalRatio': json['arrival_ratio'],
        'weightCalc': json['weight_calc'],
        'optimizeType': json['optimize_type'],
        'dateno': json['dateno'],
        'rectype': json['rectype'],
        'colname': json['colname'],
        'datevalue': (json['datevalue'] == null ? null : new Date(json['datevalue'])),
        'rectypeName': json['rectype_name'],
        'insertDatetime': (json['insert_datetime'] == null ? null : new Date(json['insert_datetime'])),
        'updateDatetime': (json['update_datetime'] == null ? null : new Date(json['update_datetime'])),
        'insertUser': json['insert_user'],
        'updateUser': json['update_user'],
        'deleteDatetime': (json['delete_datetime'] == null ? null : new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'],
        'shipQuantityPlan': ShipQuantityPlanFromJSON(json['ship_quantity_plan']),
        'arrivalQuantityPlan': ArrivalQuantityPlanFromJSON(json['arrival_quantity_plan']),
        'stockPlanUpdateDatetime': (json['stock_plan_update_datetime'] == null ? null : new Date(json['stock_plan_update_datetime'])),
        'updateDatetimeRec': (json['update_datetime_rec'] == null ? null : new Date(json['update_datetime_rec'])),
        'updateUserRec': json['update_user_rec'],
        'updateUserRecName': json['update_user_rec_name'],
        'isUpdatedArrivalTmp': json['is_updated_arrival_tmp'],
        'isOrderConfirmed': json['is_order_confirmed'],
        'orderQuantity': json['order_quantity'],
        'shipQuantityStockBase': json['ship_quantity_stock_base'],
        'avgShipQuantityStockBase': json['avg_ship_quantity_stock_base'],
        'orderQuantityLpResult': json['order_quantity_lp_result'],
        'minStockForecastBased': json['min_stock_forecast_based'],
        'minStockShortageBased': json['min_stock_shortage_based'],
        'calcSafety': json['calc_safety'],
        'isOrderQuantityFixed': json['is_order_quantity_fixed'],
        'predictionMethod': json['prediction_method'],
        'numTrain': json['num_train'],
        'yearlySeasonality': json['yearly_seasonality'],
        'predictionMapeMedian': json['prediction_mape_median'],
        'isArrivalDay': json['is_arrival_day'],
        'isOrderDay': json['is_order_day'],
        'arrivalFixDate': json['arrival_fix_date'],
        'shipdaysNextArrival': json['shipdays_next_arrival'],
        'minShipDate': (json['min_ship_date'] == null ? null : new Date(json['min_ship_date'])),
        'stockQuantityShipStop': json['stock_quantity_ship_stop'],
        'alertShipPreviousStock': json['alert_ship_previous_stock'],
        'alertLowStock': json['alert_low_stock'],
        'alertOutOfStock': json['alert_out_of_stock'],
        'masterNotFound': json['master_not_found'],
        'isInactive': json['is_inactive'],
        'unmatchLot': json['unmatch_lot'],
        'unmatchStockdays': json['unmatch_stockdays'],
        'unmatchRenewal': json['unmatch_renewal'],
        'isExpectedRankAlert': json['is_expected_rank_alert'],
        'isMinShipDateAlert': json['is_min_ship_date_alert'],
        'isEndSaleAlert': json['is_end_sale_alert'],
    };
}

export function StockToJSON(json: any): Stock {
    return StockToJSONTyped(json, false);
}

export function StockToJSONTyped(value?: Stock | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'center_id': value['centerId'],
        'org_center_id': value['orgCenterId'],
        'center_name': value['centerName'],
        'org_item_code': value['orgItemCode'],
        'org_item_code_recency': value['orgItemCodeRecency'],
        'item_code': value['itemCode'],
        'org_supplier_id': value['orgSupplierId'],
        'rec_date': value['recDate'] == null ? value['recDate'] : value['recDate'].toISOString(),
        'order_date': value['orderDate'] == null ? value['orderDate'] : value['orderDate'].toISOString(),
        'week_no': value['weekNo'],
        'date_type': value['dateType'],
        'order_quantity_rec': value['orderQuantityRec'],
        'arrival_quantity': value['arrivalQuantity'],
        'salesorder_quantity': value['salesorderQuantity'],
        'ship_quantity': value['shipQuantity'],
        'ship_quantity_rec': value['shipQuantityRec'],
        'stock_quantity': value['stockQuantity'],
        'stock_quantity_rec': value['stockQuantityRec'],
        'stock_days': value['stockDays'],
        'order_quantity_reason': value['orderQuantityReason'],
        'enable_update_ship': value['enableUpdateShip'],
        'enable_update_arrival': value['enableUpdateArrival'],
        'ship_quantity_expected': value['shipQuantityExpected'],
        'ship_expected_calc_datetime': value['shipExpectedCalcDatetime'] == null ? value['shipExpectedCalcDatetime'] : value['shipExpectedCalcDatetime'].toISOString(),
        'arrival_quantity_pallet': value['arrivalQuantityPallet'],
        'ship_quantity_pallet': value['shipQuantityPallet'],
        'stock_quantity_pallet': value['stockQuantityPallet'],
        'salesorder_quantity_pallet': value['salesorderQuantityPallet'],
        'general_customer_ship_quantity': value['generalCustomerShipQuantity'],
        'customer_order_quantity_recommend': value['customerOrderQuantityRecommend'],
        'ship_quantity_scheduled': value['shipQuantityScheduled'],
        'order_quantity_recommend': value['orderQuantityRecommend'],
        'order_recommend_calc_datetime': value['orderRecommendCalcDatetime'] == null ? value['orderRecommendCalcDatetime'] : value['orderRecommendCalcDatetime'].toISOString(),
        'stock_quantity_rec_morning': value['stockQuantityRecMorning'],
        'enable_ship': value['enableShip'],
        'enable_arrival': value['enableArrival'],
        'supplier_enable_order': value['supplierEnableOrder'],
        'enable_order': value['enableOrder'],
        'is_updated_arrival': value['isUpdatedArrival'],
        'is_updated_ship': value['isUpdatedShip'],
        'supplier_company_id': value['supplierCompanyId'],
        'arrival_fix_flg': value['arrivalFixFlg'],
        'stock_days_setting': value['stockDaysSetting'],
        'safety_stock_setting': value['safetyStockSetting'],
        'min_stock_quantity': value['minStockQuantity'],
        'start_date': value['startDate'] == null ? value['startDate'] : value['startDate'].toISOString(),
        'stop_ship': value['stopShip'],
        'stop_arrival': value['stopArrival'],
        'end_date': value['endDate'] == null ? value['endDate'] : value['endDate'].toISOString(),
        'renewal_number': value['renewalNumber'],
        'renewal_flg': value['renewalFlg'],
        'newitem_start_flg': value['newitemStartFlg'],
        'olditem_ship_stop_flg': value['olditemShipStopFlg'],
        'remarks': value['remarks'],
        'ship_exclusion_flg': value['shipExclusionFlg'],
        'ship_quantity_interpolated': value['shipQuantityInterpolated'],
        'ship_quantity_predict_base': value['shipQuantityPredictBase'],
        'ship_quantity_optimize_base': value['shipQuantityOptimizeBase'],
        'arrival_ratio': value['arrivalRatio'],
        'weight_calc': value['weightCalc'],
        'optimize_type': value['optimizeType'],
        'dateno': value['dateno'],
        'rectype': value['rectype'],
        'colname': value['colname'],
        'datevalue': value['datevalue'] == null ? value['datevalue'] : value['datevalue'].toISOString(),
        'rectype_name': value['rectypeName'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
        'ship_quantity_plan': ShipQuantityPlanToJSON(value['shipQuantityPlan']),
        'arrival_quantity_plan': ArrivalQuantityPlanToJSON(value['arrivalQuantityPlan']),
        'stock_plan_update_datetime': value['stockPlanUpdateDatetime'] == null ? value['stockPlanUpdateDatetime'] : value['stockPlanUpdateDatetime'].toISOString(),
        'update_datetime_rec': value['updateDatetimeRec'] == null ? value['updateDatetimeRec'] : value['updateDatetimeRec'].toISOString(),
        'update_user_rec': value['updateUserRec'],
        'update_user_rec_name': value['updateUserRecName'],
        'is_updated_arrival_tmp': value['isUpdatedArrivalTmp'],
        'is_order_confirmed': value['isOrderConfirmed'],
        'order_quantity': value['orderQuantity'],
        'ship_quantity_stock_base': value['shipQuantityStockBase'],
        'avg_ship_quantity_stock_base': value['avgShipQuantityStockBase'],
        'order_quantity_lp_result': value['orderQuantityLpResult'],
        'min_stock_forecast_based': value['minStockForecastBased'],
        'min_stock_shortage_based': value['minStockShortageBased'],
        'calc_safety': value['calcSafety'],
        'is_order_quantity_fixed': value['isOrderQuantityFixed'],
        'prediction_method': value['predictionMethod'],
        'num_train': value['numTrain'],
        'yearly_seasonality': value['yearlySeasonality'],
        'prediction_mape_median': value['predictionMapeMedian'],
        'is_arrival_day': value['isArrivalDay'],
        'is_order_day': value['isOrderDay'],
        'arrival_fix_date': value['arrivalFixDate'],
        'shipdays_next_arrival': value['shipdaysNextArrival'],
        'min_ship_date': value['minShipDate'] == null ? value['minShipDate'] : value['minShipDate'].toISOString(),
        'stock_quantity_ship_stop': value['stockQuantityShipStop'],
        'alert_ship_previous_stock': value['alertShipPreviousStock'],
        'alert_low_stock': value['alertLowStock'],
        'alert_out_of_stock': value['alertOutOfStock'],
        'master_not_found': value['masterNotFound'],
        'is_inactive': value['isInactive'],
        'unmatch_lot': value['unmatchLot'],
        'unmatch_stockdays': value['unmatchStockdays'],
        'unmatch_renewal': value['unmatchRenewal'],
        'is_expected_rank_alert': value['isExpectedRankAlert'],
        'is_min_ship_date_alert': value['isMinShipDateAlert'],
        'is_end_sale_alert': value['isEndSaleAlert'],
    };
}

